import {Component} from '@angular/core';
import {LoaderService} from '../../services/loader.service';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent {

  isLoading$ = this.loaderService.isLoading$;

  constructor(private loaderService: LoaderService) { }

}
